import React, { Component, PropTypes } from 'react';

export default class Modal extends Component {

    static propTypes = {
        id: PropTypes.string.isRequired,
        header: PropTypes.string.isRequired,
        isSaving: PropTypes.bool.isRequired,
        clickNegativeHandler: PropTypes.func,
        clickPositiveHandler: PropTypes.func,
        positiveButton: PropTypes.string,
        negativeButton: PropTypes.string,
        optionalButton: PropTypes.string,
        optionalButton2: PropTypes.string,
        buttonBackgroundColor: PropTypes.string,
        loadingText: PropTypes.string
    }

    static defaultProps = {
        positiveButton: 'Save',
        negativeButton: 'Close',
        buttonBackgroundColor: 'btn blue',
        loadingText : 'Saving' 
    }

    componentDidMount() {
        
    }

    componentWillReceiveProps(nextProps) {
        
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    handleClickPositive = () => {
        this.props.onPositiveClickEvent();
    }

    handleClickNegative = () => {
        this.props.onNegativeClickEvent();
    }

    handleClickOptionalButton = () => {

    }

    handleOnOptionalButton = (e) => {
        this.props.onOptionalButtonClickEvent(e);
    }

    handleOnOptionalButton2 = (e) => {
        this.props.onOptionalButton2ClickEvent(e);
    }

    render() {
        return (
            <div id={this.props.id} data-width={this.props.width ? this.props.width : '760'} className="modal fade in" tabIndex="-1" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" onClick={this.handleClickNegative} data-dismiss="modal" aria-hidden="true"></button>
                        <h4 className="modal-title">{this.props.header}</h4>
                    </div>
                    <div className="modal-body">
                        {this.props.children}
                    </div>
                    { this.props.isSaving ? (
                        <div className="modal-footer">
                            <button type="button" data-dismiss="modal" className="btn dark btn-outline" disabled>
                                Close
                            </button>
                            <button type="button" className="btn blue" disabled>
                                <i className="fa fa-spinner fa-spin" aria-hidden="true"/> &nbsp;
                                {this.props.loadingText}
                            </button>
                        </div>
                    ) : (
                        <div className="modal-footer">
                            {this.props.optionalButton ?
                                <button type="button" className="btn btn-outline pull-left" onClick={this.handleOnOptionalButton}>
                                        {this.props.optionalButton}
                                </button>
                            :
                                null
                            }

                            {this.props.optionalButton2 ?
                                <button type="button" className="btn btn-outline pull-left" onClick={this.handleOnOptionalButton2}>
                                        {this.props.optionalButton2}
                                </button>
                            :
                                null
                            }
                            <button type="button" className="btn dark btn-outline" onClick={this.handleClickNegative} data-dismiss="modal" >
                                {this.props.negativeButton}
                            </button>
                            <button type="button" className={this.props.buttonBackgroundColor} onClick={this.handleClickPositive}>
                                {this.props.positiveButton}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Modal/Modal.js
 **/